export default __webpack_public_path__ + "848f3a6e80058194c450d0bc7e93080f.woff";